<template>
  <base-container class="trending-videos" :fluid="true">
    <base-container>
      <h2 class="lvl2-heading">
        {{ slider.name }}
      </h2>
    </base-container>
    <Carousel :videos="slider.videos" />
  </base-container>
</template>

<script>
import Carousel from "@/components/Carousel.vue"
export default {
  props: {
    slider: {
      type: Object,
      required: true
    }
  },
  components: {
    Carousel
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.trending-videos {
  margin-top: 36px;

  .video-thumbnail {
    $play-button-icon-size: 55px;
    &__play-icon-container {
      height: $play-button-icon-size;
      width: $play-button-icon-size;
    }
  }
}
</style>
